import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_LINK_ACTION_STATE } from '../../../constants/createSendLinkAction';
import { ICreateSendLinkActionState } from '../../../types/createSendLinkAction';
import * as AuthActions from '../../actions/auth';
import * as LinkActionActions from '../actions/linkAction';

export const initialState: ICreateSendLinkActionState = DEFAULT_CREATE_SEND_LINK_ACTION_STATE;

const reducer = (state: ICreateSendLinkActionState = initialState, action: any): ICreateSendLinkActionState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT: {
      return initialState;
    }
    case LinkActionActions.CS_LINK_ACTION_REQUESTED: {
      return {
        target: action.payload.target,
        generation: state.generation + 1,
      };
    }
    default:
      return state;
  }
};

export default reducer;
